<template>
  <div>
    <div :class="{'folder': isFolder }" >
      <div
        class="root-item d-flex justify-content-between align-items-center"
        :class="{'highlight': !item.id_padre}"
      >
        <div
          @click="toggle(item)"
          :class="{active: nodeSelected === item.id}"
        >
          <span v-if="isFolder">{{ isOpen ? '-' : '+' }}</span>
          {{ item.nombre }}
        </div>
      </div>
      <ul
        class="list"
        v-show="isOpen"
        v-if="isFolder"
      >
        <li
          v-for="child of item.children"
          class="d-flex items-center justify-content-between tree-item"
          :key="child.id"
          @click="selected(child)"
        >

          <tree-item
            :item="child"
            @selected="$emit('selected', $event)"
            :node-selected="nodeSelected"
          />

        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TreeItem',
  props: {
    item: Object,
    nodeSelected: Number
  },
  data () {
    return {
      isOpen: false,
    }
  },
  computed: {
    isFolder () {
      return this.item.children && this.item.children.length
    }
  },
  methods: {
    toggle (node) {

      if (this.isFolder) {
        this.isOpen = !this.isOpen
      }
      this.selected(node)
    },
    selected (node) {
      if (!this.isFolder) {
        this.$emit('selected', node)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.root-item {
  padding: 8px;
  cursor: pointer;
  margin: 3px 5px;
  border-radius: 3px;
}
.active {
  font-weight: bold;
}
.highlight {
  background-color: #eee;
}
.list {
  padding: 0;
  margin: 0 5px;
}
.tree-item {
  padding-left: 20px;
  cursor: pointer;
}
</style>
